import React, { useEffect, useState, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import {
  Upload, Checkbox, Popconfirm, notification,
} from 'antd';
import {
  PlusOutlined,
} from '@ant-design/icons';
import H3FormInput from '@Uilib/h3FormInput';
import H3Text from '@Uilib/h3Text';
import Constants from '@Apis/constants';
import TemplateRouteActions from '@Actions/production/templateRouteActions';
import ResourceActions from '@Actions/production/resourceActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import Crown from '@Images/crown2.png';
import SelectResourceGroup from '@Components/Common/SelectResourceGroup';
import './style.scss';

const uploadButton = (
  <div>
    <PlusOutlined />
    <div style={{ marginTop: 8 }}>Upload</div>
  </div>
);

/**
 *
 */
const TemplateRouteForm = ({
  createTemplateRoute, createTemplateRouteLoading, user, updateTemplateRouteLoading, selectedTemplateRoute, callback, updateTemplateRoute,
}) => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [templateRouteName, setTemplateRouteName] = useState('');
  const [isSequential, setIsSequential] = useState(true);
  const [isTimeTrackingEnabled, setIsTimeTrackingEnabled] = useState(true);
  const [data, setData] = useState([{
    key: uuidv4(),
    step_number: 1,
  }]);

  useEffect(() => {
    if (selectedTemplateRoute) {
      setTemplateRouteName(selectedTemplateRoute?.template_route_name);
      setIsSequential(selectedTemplateRoute?.is_sequential);
      setIsTimeTrackingEnabled(selectedTemplateRoute?.is_time_tracked);
      setData(selectedTemplateRoute?.tpr_lines?.map((item) => ({
        ...item,
        key: uuidv4(),
        fileList: item.attachments,
        machine_resource_group: item?.machine_resource_group?.resource_group_id,
        equipment_resource_group: item?.equipments_resource_groups?.map((i) => i?.resource_group_id),
        other_resources_group: item?.other_resource_groups?.map((i) => i?.resource_group_id),
      })));
    }
  }, []);

  const addNewRow = (key) => {
    const copyData = JSON.parse(JSON.stringify(data));
    if (!key) {
      copyData.push({
        key: uuidv4(),
        process_name: '',
        step_number: copyData.length + 1,
        resource_ids: [],
      });
      setData(copyData);
    } else {
      const newData = [];
      for (let i = 0; i < copyData?.length; i++) {
        if (copyData[i]?.key === key) {
          newData.push({
            key: uuidv4(),
            process_name: '',
            step_number: copyData.length + 1,
            resource_ids: [],
          });
        }
        newData.push(copyData[i]);
      }
      setData(newData);
    }
  };

  const handleDelete = (key) => {
    if (data?.length > 1) {
      const copyData = data.filter((item) => item.key !== key);
      const newCopyData = copyData?.map((item, index) => ({ ...item, step_number: index + 1 }));
      setData(newCopyData);
    } else {
      notification.open({
        type: 'error',
        message: 'At least one step is required to create a Template Route',
        duration: 4,
        placement: 'top',
      });
    }
  };

  const isDataValid = () => {
    const copyData = JSON.parse(JSON.stringify(data));
    let isValid = true;
    for (let i = 0; i < copyData?.length; i++) {
      if (!copyData[i]?.process_name) {
        isValid = false;
      }
    }
    return isValid;
  };

  const addTemplateRoute = () => {
    setFormSubmitted(true);

    const requiredData = data?.map((item, index) => ({
      template_production_route_line_id: item?.template_production_route_line_id,
      step_number: index + 1,
      process_name: item?.process_name,
      machine_resource_group_id: item?.machine_resource_group || null,
      attachments: item?.fileList,
      remarks: item?.remarks || '',
    }));

    if (isDataValid() && templateRouteName) {
      if (selectedTemplateRoute) {
        const payload = {
          org_id: user?.tenant_info?.org_id,
          template_production_route_id: selectedTemplateRoute?.template_production_route_id,
          template_route_name: templateRouteName,
          is_sequential: isSequential,
          is_time_tracked: isTimeTrackingEnabled,
          tpr_lines: requiredData,
        };
        updateTemplateRoute(payload, () => {
          callback();
        });
      } else {
        const payload = {
          org_id: user?.tenant_info?.org_id,
          template_route_name: templateRouteName,
          is_sequential: isSequential,
          is_time_tracked: isTimeTrackingEnabled,
          tpr_lines: requiredData,
        };
        createTemplateRoute(payload, () => {
          callback();
        });
      }
    }
  };

  const dataSource = () => {
    const copyData = JSON.parse(JSON.stringify(data));
    return copyData;
  };
  const factorySetup = user?.tenant_info?.production_config?.addons?.factory_setup?.is_active;

  return (
    <Fragment>
      <div className="template-routes-create__wrapper" style={{ marginBottom: '40px' }}>
        <div className="ant-row">
          <div className="ant-col-md-12 ant-col-xs-24">
            <H3FormInput
              name="process name"
              type="text"
              containerClassName="orgInputContainer"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => setTemplateRouteName(event.target.value)}
              value={templateRouteName}
              disabled={createTemplateRouteLoading || updateTemplateRouteLoading}
              label="Process Name"
              maxlength="100"
              required
              showError={formSubmitted && !templateRouteName}
            />
          </div>
          {/* <div className="ant-col-md-24">
            <Checkbox
              checked={isSequential}
              onChange={() => {
                setIsSequential(!isSequential);
              }}
            >
              Sequential Process Execution
            </Checkbox>
          </div>
          <div className="ant-col-md-24">
            <Checkbox
              checked={isTimeTrackingEnabled}
              onChange={() => {
                setIsTimeTrackingEnabled(!isTimeTrackingEnabled);
              }}
            >
              Time Tracking Enabled
            </Checkbox>
          </div> */}
        </div>
        <H3Text text="" className="template-routes__section-title" />
        {
          dataSource()?.map((record, index) => (
            <div key={index} className="template-route__step">
              <div className="template-route__step-info">
                <div className="template-route__step-count" onClick={() => addNewRow(record?.key)}>
                  <H3Text text={index + 1} className="template-route__step-count-text" />
                  <H3Text text="+" className="template-route__step-count-add" />
                </div>
                <H3Text text="" className="template-route__step-line" />
              </div>
              <div className="template-route__step-details">
                <div className="ant-row">
                  <div className="ant-col-md-12">
                    <div style={{ width: '98%' }}>
                      <H3FormInput
                        label="Step Name"
                        required
                        value={record?.process_name}
                        type="text"
                        labelClassName="orgFormLabel template-route__step-details-label"
                        inputClassName="orgFormInput"
                        onChange={(event) => {
                          const copyData = JSON.parse(JSON.stringify(data));
                          for (let i = 0; i < data?.length; i++) {
                            if (copyData[i]?.key === record?.key) {
                              copyData[i].process_name = event.target.value;
                              break;
                            }
                          }
                          setData(copyData);
                        }}
                      />
                    </div>
                  </div>
                  <div className="ant-col-md-12">
                    <H3Text className="template-route__step-details-label orgFormLabel" text="Work Center" />
                    <SelectResourceGroup
                      selectedResourceGroup={record?.machine_resource_group}
                      onChange={(value) => {
                        const copyData = JSON.parse(JSON.stringify(data));
                        for (let i = 0; i < copyData?.length; i++) {
                          if (copyData[i]?.key === record?.key) {
                            copyData[i].machine_resource_group = value;
                            break;
                          }
                        }
                        setData(copyData);
                      }}
                      resourceType="MACHINE"
                      dropdownWidth="100%"
                      maxTagCount="responsive"
                    />
                  </div>
                  {/* <div className="ant-col-md-12"> */}
                  {/*  <H3Text className="template-route__step-details-label orgFormLabel" text="Select Equipment Group" /> */}
                  {/*  <SelectResourceGroup */}
                  {/*    selectedResourceGroup={record?.equipment_resource_group} */}
                  {/*    onChange={(value) => { */}
                  {/*      const copyData = JSON.parse(JSON.stringify(data)); */}
                  {/*      const resourceIdsArr = []; */}
                  {/*      for (let i = 0; i < value?.length; i++) { */}
                  {/*        resourceIdsArr.push(value[i]); */}
                  {/*      } */}

                  {/*      for (let i = 0; i < copyData?.length; i++) { */}
                  {/*        if (copyData[i]?.key === record?.key) { */}
                  {/*          copyData[i].equipment_resource_group = resourceIdsArr; */}
                  {/*          break; */}
                  {/*        } */}
                  {/*      } */}
                  {/*      setData(copyData); */}
                  {/*    }} */}
                  {/*    resourceType="EQUIPMENT" */}
                  {/*    mode="multiple" */}
                  {/*    dropdownWidth="98%" */}
                  {/*    maxTagCount="responsive" */}
                  {/*  /> */}
                  {/* </div> */}
                  {/* <div className="ant-col-md-8"> */}
                  {/*  <H3Text className="template-route__step-details-label orgFormLabel" text="Select Other Group" /> */}
                  {/*  <SelectResourceGroup */}
                  {/*    selectedResourceGroup={record?.other_resources_group} */}
                  {/*    onChange={(value) => { */}
                  {/*      const copyData = JSON.parse(JSON.stringify(data)); */}
                  {/*      const resourceIdsArr = []; */}
                  {/*      for (let i = 0; i < value?.length; i++) { */}
                  {/*        resourceIdsArr.push(value[i]); */}
                  {/*      } */}

                  {/*      for (let i = 0; i < copyData?.length; i++) { */}
                  {/*        if (copyData[i]?.key === record?.key) { */}
                  {/*          copyData[i].other_resources_group = resourceIdsArr; */}
                  {/*          break; */}
                  {/*        } */}
                  {/*      } */}
                  {/*      setData(copyData); */}
                  {/*    }} */}
                  {/*    resourceType="OTHER" */}
                  {/*    mode="multiple" */}
                  {/*    dropdownWidth="100%" */}
                  {/*    maxTagCount="responsive" */}
                  {/*  /> */}
                  {/* </div> */}
                  <div className="ant-col-md-12">
                    <H3FormInput
                      label="Instructions"
                      value={record.remarks}
                      type="text"
                      isTextarea
                      labelClassName="orgFormLabel template-route__step-details-label"
                      inputClassName="template-route__step-details-textarea"
                      onChange={(event) => {
                        const copyData = JSON.parse(JSON.stringify(data));
                        for (let i = 0; i < data?.length; i++) {
                          if (copyData[i]?.key === record?.key) {
                            copyData[i].remarks = event.target.value;
                            break;
                          }
                        }
                        setData(copyData);
                      }}
                    />
                  </div>
                  <div className="ant-col-md-10">
                    <H3Text className="template-route__step-details-label orgFormLabel" text="Attachments" />
                    <div className="template-route-form__upload-container">
                      <Upload
                        action={Constants.UPLOAD_FILE}
                        listType="picture-card"
                        fileList={record?.fileList}
                        disabled={createTemplateRouteLoading || updateTemplateRouteLoading}
                        onChange={(fileListData) => {
                          const copyData = JSON.parse(JSON.stringify(data));
                          for (let i = 0; i < data?.length; i++) {
                            if (copyData[i]?.key === record?.key) {
                              copyData[i].fileList = fileListData?.fileList?.map((item) => ({
                                ...item,
                                url: item?.response?.response?.location || item?.url,
                              }));
                              break;
                            }
                          }
                          setData(copyData);
                        }}
                      >
                        {record?.fileList?.length >= 20 ? null : uploadButton}
                      </Upload>
                    </div>
                  </div>
                  <div className="ant-col-md-2">
                    <Popconfirm
                      placement="topRight"
                      title="Are you sure you want to delete this Step?"
                      onConfirm={() => handleDelete(record?.key)}
                      okText="Yes"
                      cancelText="No"
                    >
                      <H3Text text="remove" className="template-route__step-details-remove" />
                    </Popconfirm>
                  </div>
                </div>
              </div>
            </div>
          ))
        }
        <div className="template-route__step-add" onClick={() => addNewRow()}>
          +
        </div>

        <div className="custom-drawer__footer">
          <div className="ant-col-md-6" style={{ marginTop: '0.5rem' }}>
            <div className="indent-barcode__wrapper" style={{ display: 'flex' }}>
              <H3Button
                buttonType={defaultButtonTypes.BLUE_ROUNDED}
                text={selectedTemplateRoute ? 'Update Process' : 'Create Process'}
                onClick={() => addTemplateRoute()}
                isLoading={createTemplateRouteLoading || updateTemplateRouteLoading}
                disabled={createTemplateRouteLoading || updateTemplateRouteLoading || !factorySetup}
                style={{
                  width: '180px',
                  borderRadius: '5px',
                  padding: '7px 0px',
                  marginLeft: '0',
                }}
              />
              {!factorySetup && (
                <Popconfirm
                  placement="topRight"
                  title="This feature is not accessible within your current plan to use this feature contact us."
                  onConfirm={() => window.Intercom('showNewMessage')}
                  okText="Contact Us"
                  cancelText="Cancel"
                >
                  <img
                    className="barcode-restrict"
                    src={Crown}
                    alt="premium"
                    style={{
                      marginLeft: '8px',
                      marginTop: '5px',
                    }}
                  />
                </Popconfirm>
              )}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, TemplateRouteReducers, ResourceReducers, ProcessReducers,
}) => ({
  user: UserReducers.user,
  createTemplateRouteLoading: TemplateRouteReducers.createTemplateRouteLoading,
  updateTemplateRouteLoading: TemplateRouteReducers.updateTemplateRouteLoading,
  resourcesGroup: ResourceReducers.resourcesGroup,
  dropdownResources: ResourceReducers.dropdownResources,
  getProcessesLoading: ProcessReducers.getProcessesLoading,
  processes: ProcessReducers.processes,
  createResourceGroupLoading: ResourceReducers.createResourceGroupLoading,
});

const mapDispatchToProps = (dispatch) => ({
  createTemplateRoute: (payload, callback) => dispatch(TemplateRouteActions.createTemplateRoute(payload, callback)),
  updateTemplateRoute: (payload, callback) => dispatch(TemplateRouteActions.updateTemplateRoute(payload, callback)),
  getTemplateRoute: (orgId, page, limit, searchKeyword) => dispatch(TemplateRouteActions.getTemplateRoutes(orgId, page, limit, searchKeyword)),
  getResource: (orgId, page, limit, searchKeyword, tenantIds, resourceType, resourceStatus, isDropdown) => dispatch(ResourceActions.getResource(orgId, page, limit, searchKeyword, tenantIds, resourceType, resourceStatus, isDropdown)),
  createResourceGroup: (payload, callback) => dispatch(ResourceActions.createResourceGroup(payload, callback)),
});

TemplateRouteForm.propTypes = {
  user: PropTypes.any,
  createTemplateRouteLoading: PropTypes.bool,
  updateTemplateRouteLoading: PropTypes.bool,
  callback: PropTypes.func,
  createTemplateRoute: PropTypes.func,
  selectedTemplateRoute: PropTypes.any,
  updateTemplateRoute: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TemplateRouteForm));
